import { render, staticRenderFns } from "./BecomeACreatorStats.vue?vue&type=template&id=a5c91f9e"
import script from "./BecomeACreatorStats.vue?vue&type=script&lang=js"
export * from "./BecomeACreatorStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports